import Dexie, { type EntityTable } from 'dexie';
import type { CachedEntity, IdMapping, SyncQueueItem } from './types';

export interface MetaEntry {
  key: string;
  value: string;
}

export interface CompositeCacheEntry {
  key: string;
  data: unknown;
  _localUpdatedAt: string;
}

class CoachAppDB extends Dexie {
  clients!: EntityTable<CachedEntity, 'id'>;
  bookings!: EntityTable<CachedEntity, 'id'>;
  tasks!: EntityTable<CachedEntity, 'id'>;
  leads!: EntityTable<CachedEntity, 'id'>;
  measurements!: EntityTable<CachedEntity, 'id'>;
  packages!: EntityTable<CachedEntity, 'id'>;
  challenges!: EntityTable<CachedEntity, 'id'>;
  trainingPlans!: EntityTable<CachedEntity, 'id'>;
  syncQueue!: EntityTable<SyncQueueItem, 'id'>;
  idMappings!: EntityTable<IdMapping, 'tempId'>;
  compositeCache!: EntityTable<CompositeCacheEntry, 'key'>;
  meta!: EntityTable<MetaEntry, 'key'>;

  constructor() {
    super('CoachAppOffline');

    this.version(1).stores({
      clients: 'id, trainerId, _localUpdatedAt',
      bookings: 'id, trainerId, clientId, _localUpdatedAt',
      tasks: 'id, trainerId, clientId, status, _localUpdatedAt',
      leads: 'id, trainerId, _localUpdatedAt',
      measurements: 'id, clientId, _localUpdatedAt',
      packages: 'id, clientId, trainerId, _localUpdatedAt',
      challenges: 'id, clientId, trainerId, _localUpdatedAt',
      trainingPlans: 'id, clientId, trainerId, _localUpdatedAt',
      syncQueue: 'id, createdAt, entityType',
      idMappings: 'tempId, entityType',
      compositeCache: 'key, _localUpdatedAt',
      meta: 'key',
    });
  }
}

export const db = new CoachAppDB();

export async function getMeta(key: string): Promise<string | null> {
  const entry = await db.meta.get(key);
  return entry?.value ?? null;
}

export async function setMeta(key: string, value: string): Promise<void> {
  await db.meta.put({ key, value });
}
